// src/constants/spotMeta.js

/**
 * スポット静的メタ情報
 *
 * 【運用ルール】
 * - スポット追加時: ここに新しいエントリを追加してデプロイ
 * - 画像・住所変更時: 対象スポットのエントリを更新してデプロイ
 * - キー形式: `${rallyId}_${spotNumber}`（Firestoreの mapSpots ドキュメントIDと一致）
 *
 * 【サムネイルについて】
 * - thumbnailUrls は配列で、各スポットに複数画像を持てる
 * - 画像がまだ準備されていない場合は空配列にしておく（UIでプレースホルダーを表示）
 * - 画像パスは public/ ルートからの相対パス
 *
 * 【現在のディレクトリ構造】
 * public/images/rallies/{rallyId}/spots/{spotId}/
 *   card-1.png  … 無料カード画像
 *   card-2.png  … 有料カード画像
 *   stamp-stack.png
 * ※ ueno_1 のみ card-1.png が存在しないため card-2.png を使用
 */
export const SPOT_META = {
  ueno_1: {
    thumbnailUrls: [
      '/images/rallies/ueno/spots/ueno_1/card-1.png',
      '/images/rallies/ueno/spots/ueno_1/card-2.png',
    ],
    address: '東京都台東区上野公園',
  },
  ueno_2: {
    thumbnailUrls: [
      '/images/rallies/ueno/spots/ueno_2/card-1.png',  // 無料版
      '/images/rallies/ueno/spots/ueno_2/card-2.png',  // 有料版
    ],
    address: '東京都台東区上野公園',
  },
  ueno_3: {
    thumbnailUrls: [
      '/images/rallies/ueno/spots/ueno_3/card-1.png',
      '/images/rallies/ueno/spots/ueno_3/card-2.png',
    ],
    address: '東京都台東区上野',
  },
  ueno_4: {
    thumbnailUrls: [
      '/images/rallies/ueno/spots/ueno_4/card-1.png',
      '/images/rallies/ueno/spots/ueno_4/card-2.png',
    ],
    address: '東京都台東区上野6丁目',
  },
  ueno_5: {
    thumbnailUrls: [
      '/images/rallies/ueno/spots/ueno_5/card-1.png',
      '/images/rallies/ueno/spots/ueno_5/card-2.png',
    ],
    address: '東京都台東区台東1丁目',
  },
  ueno_6: {
    thumbnailUrls: [
      '/images/rallies/ueno/spots/ueno_6/card-1.png',
      '/images/rallies/ueno/spots/ueno_6/card-2.png',
    ],
    address: '東京都台東区上野4丁目',
  },
  // ── 桂浜水族館周辺スポットラリー ─────────────────────────────
  katsurahama_7: {
    thumbnailUrls: [
      '/images/rallies/katsurahama/spots/katsurahama_7/card-1.jpg',
      '/images/rallies/katsurahama/spots/katsurahama_7/card-2.jpg',
    ],
    address: '高知県高知市浦戸',
  },
  katsurahama_8: {
    thumbnailUrls: [
      '/images/rallies/katsurahama/spots/katsurahama_8/card-1.jpg',
      '/images/rallies/katsurahama/spots/katsurahama_8/card-2.jpg',
    ],
    address: '高知県香南市野市町大谷',
  },
  katsurahama_9: {
    thumbnailUrls: [
      '/images/rallies/katsurahama/spots/katsurahama_9/card-1.jpg',
      '/images/rallies/katsurahama/spots/katsurahama_9/card-2.jpg',
    ],
    address: '高知県南国市久枝',
  },
  katsurahama_10: {
    thumbnailUrls: [
      '/images/rallies/katsurahama/spots/katsurahama_10/card-1.jpg',
      '/images/rallies/katsurahama/spots/katsurahama_10/card-2.jpg',
    ],
    address: '高知県高知市浦戸',
  },
  katsurahama_11: {
    thumbnailUrls: [
      '/images/rallies/katsurahama/spots/katsurahama_11/card-1.jpg',
      '/images/rallies/katsurahama/spots/katsurahama_11/card-2.jpg',
    ],
    address: '高知県高知市浦戸',
  },
  katsurahama_12: {
    thumbnailUrls: [
      '/images/rallies/katsurahama/spots/katsurahama_12/card-1.jpg',
      '/images/rallies/katsurahama/spots/katsurahama_12/card-2.jpg',
    ],
    address: '高知県高知市はりまや町',
  },
  katsurahama_13: {
    // card-1.jpg は未作成のため card-2.jpg のみ
    thumbnailUrls: [
      '/images/rallies/katsurahama/spots/katsurahama_13/card-2.jpg',
    ],
    address: '',
  },
  kasairinkai_14: {
    thumbnailUrls: [
      '/images/rallies/kasairinkai/spots/kasairinkai_14/card-1.jpg',
      '/images/rallies/kasairinkai/spots/kasairinkai_14/card-2.jpg',
    ],
    address: '東京都千代田区有楽町2丁目',
  },
  kasairinkai_15: {
    thumbnailUrls: [
      '/images/rallies/kasairinkai/spots/kasairinkai_15/card-1.jpg',
      '/images/rallies/kasairinkai/spots/kasairinkai_15/card-2.jpg',
    ],
    address: '東京都千代田区日比谷公園1',
  },
  kasairinkai_16: {
    thumbnailUrls: [
      '/images/rallies/kasairinkai/spots/kasairinkai_16/card-1.jpg',
      '/images/rallies/kasairinkai/spots/kasairinkai_16/card-2.jpg',
    ],
    address: '東京都中央区銀座',
  },
  kasairinkai_17: {
    thumbnailUrls: [
      '/images/rallies/kasairinkai/spots/kasairinkai_17/card-1.jpg',
      '/images/rallies/kasairinkai/spots/kasairinkai_17/card-2.jpg',
    ],
    address: '東京都江戸川区臨海町6丁目',
  },
  kasairinkai_18: {
    thumbnailUrls: [
      '/images/rallies/kasairinkai/spots/kasairinkai_18/card-1.jpg',
      '/images/rallies/kasairinkai/spots/kasairinkai_18/card-2.jpg',
    ],
    address: '東京都江戸川区臨海町6丁目',
  },
  kasairinkai_19: {
    thumbnailUrls: [
      '/images/rallies/kasairinkai/spots/kasairinkai_19/card-1.jpg',
      '/images/rallies/kasairinkai/spots/kasairinkai_18/card-2.jpg',
    ],
    address: '東京都江東区夢の島2丁目',
  },
  kasairinkai_20: {
    thumbnailUrls: [],
    address: '',
  },
  // 新しいラリー・スポットが追加された場合はここに追記してデプロイ
  // kyoto_1: { thumbnailUrls: [...], address: '...' },

  // ── all ラリー（日本全国 動物園・水族館スポットラリー）────────────────
  // 画像は public/images/rallies/all/spots/{spotId}/card-1.{jpg|png} に配置する
  all_21: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_21/card-1.jpg',  // 無料版
      '/images/rallies/all/spots/all_21/card-2.jpg',  // 有料版
    ],
    address: '北海道帯広市緑ケ丘',
  },
  all_22: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_22/card-1.jpg',
      '/images/rallies/all/spots/all_22/card-2.jpg',
    ],
    address: '岩手県盛岡市本宮',
  },
  all_23: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_23/card-1.jpg',
      '/images/rallies/all/spots/all_23/card-2.jpg',
    ],
    address: '宮城県仙台市太白区八木山本町',
  },
  all_24: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_24/card-1.jpg',
      '/images/rallies/all/spots/all_24/card-2.jpg',
    ],
    address: '福島県いわき市小名浜辰巳町',
  },
  all_25: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_25/card-1.jpg',
      '/images/rallies/all/spots/all_25/card-2.jpg',
    ],
    address: '栃木県那須郡那須町大島',
  },
  all_26: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_26/card-1.jpg',
      '/images/rallies/all/spots/all_26/card-2.jpg',
    ],
    address: '埼玉県南埼玉郡宮代町須賀',
  },
  all_27: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_27/card-1.jpg',
      '/images/rallies/all/spots/all_27/card-2.jpg',
    ],
    address: '東京都日野市程久保',
  },
  all_28: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_28/card-1.jpg',
      '/images/rallies/all/spots/all_28/card-2.jpg',
    ],
    address: '東京都武蔵野市御殿山',
  },
  all_29: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_29/card-1.jpg',
      '/images/rallies/all/spots/all_29/card-2.jpg',
    ],
    address: '千葉県千葉市若葉区源町',
  },
  all_30: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_30/card-1.jpg',
      '/images/rallies/all/spots/all_30/card-2.jpg',
    ],
    address: '神奈川県横浜市西区老松町',
  },
  all_31: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_31/card-1.jpg',
      '/images/rallies/all/spots/all_31/card-2.jpg',
    ],
    address: '千葉県市原市山小川',
  },
  all_32: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_32/card-1.jpg',
      '/images/rallies/all/spots/all_32/card-2.jpg',
    ],
    address: '千葉県鴨川市東町',
  },
  all_33: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_33/card-1.jpg',
      '/images/rallies/all/spots/all_33/card-2.jpg',
    ],
    address: '東京都豊島区東池袋3丁目',
  },
  all_34: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_34/card-1.jpg',
      '/images/rallies/all/spots/all_34/card-2.jpg',
    ],
    address: '東京都港区高輪4丁目',
  },
  all_35: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_35/card-1.jpg',
      '/images/rallies/all/spots/all_35/card-2.jpg',
    ],
    address: '神奈川県横浜市旭区上白根町',
  },
  all_36: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_36/card-1.jpg',
      '/images/rallies/all/spots/all_36/card-2.jpg',
    ],
    address: '',
  },
  all_37: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_37/card-1.jpg',
      '/images/rallies/all/spots/all_37/card-2.jpg',
    ],
    address: '',
  },
  all_38: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_38/card-1.jpg',
      '/images/rallies/all/spots/all_38/card-2.jpg',
    ],
    address: '',
  },
  all_39: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_39/card-1.jpg',
      '/images/rallies/all/spots/all_39/card-2.jpg',
    ],
    address: '',
  },

  // ── all ラリー西日本 ─────────────────────────────────────────────
  all_40: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_40/card-1.jpg',
      '/images/rallies/all/spots/all_40/card-2.jpg',
    ],
    address: '',
  },
  all_41: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_41/card-1.jpg',
      '/images/rallies/all/spots/all_41/card-2.jpg',
    ],
    address: '',
  },
  all_42: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_42/card-1.jpg',
      '/images/rallies/all/spots/all_42/card-2.jpg',
    ],
    address: '',
  },
  all_43: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_43/card-1.jpg',
      '/images/rallies/all/spots/all_43/card-2.jpg',
    ],
    address: '',
  },
  all_44: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_44/card-1.jpg',
      '/images/rallies/all/spots/all_44/card-2.jpg',
    ],
    address: '',
  },
  all_45: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_45/card-1.jpg',
      '/images/rallies/all/spots/all_45/card-2.jpg',
    ],
    address: '',
  },
  all_46: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_46/card-1.jpg',
      '/images/rallies/all/spots/all_46/card-2.jpg',
    ],
    address: '',
  },
  all_47: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_47/card-1.jpg',
      '/images/rallies/all/spots/all_47/card-2.jpg',
    ],
    address: '',
  },
  all_48: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_48/card-1.jpg',
      '/images/rallies/all/spots/all_48/card-2.jpg',
    ],
    address: '',
  },
  all_49: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_49/card-1.jpg',
      '/images/rallies/all/spots/all_49/card-2.jpg',
    ],
    address: '',
  },
  all_50: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_50/card-1.jpg',
      '/images/rallies/all/spots/all_50/card-2.jpg',
    ],
    address: '',
  },
  all_51: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_51/card-1.jpg',
      '/images/rallies/all/spots/all_51/card-2.jpg',
    ],
    address: '',
  },
  all_52: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_52/card-1.jpg',
      '/images/rallies/all/spots/all_52/card-2.jpg',
    ],
    address: '',
  },

  // ── chibazoo ラリー ───────────────────────────────────────────
  chibazoo_53: {
    thumbnailUrls: [
      '/images/rallies/chibazoo/spots/chibazoo_53/card-1.jpg',
      '/images/rallies/chibazoo/spots/chibazoo_53/card-2.jpg',
    ],
    address: '',
  },
  chibazoo_54: {
    thumbnailUrls: [
      '/images/rallies/chibazoo/spots/chibazoo_54/card-1.jpg',
      '/images/rallies/chibazoo/spots/chibazoo_54/card-2.jpg',
    ],
    address: '',
  },
  chibazoo_55: {
    thumbnailUrls: [
      '/images/rallies/chibazoo/spots/chibazoo_55/card-1.jpg',
      '/images/rallies/chibazoo/spots/chibazoo_55/card-2.jpg',
    ],
    address: '',
  },
  chibazoo_56: {
    thumbnailUrls: [
      '/images/rallies/chibazoo/spots/chibazoo_56/card-1.jpg',
      '/images/rallies/chibazoo/spots/chibazoo_56/card-2.jpg',
    ],
    address: '',
  },
  chibazoo_57: {
    thumbnailUrls: [
      '/images/rallies/chibazoo/spots/chibazoo_57/card-1.jpg',
      '/images/rallies/chibazoo/spots/chibazoo_57/card-2.jpg',
    ],
    address: '',
  },
  chibazoo_58: {
    thumbnailUrls: [
      '/images/rallies/chibazoo/spots/chibazoo_58/card-1.jpg',
      '/images/rallies/chibazoo/spots/chibazoo_58/card-2.jpg',
    ],
    address: '',
  },
  chibazoo_59: {
    thumbnailUrls: [
      '/images/rallies/chibazoo/spots/chibazoo_59/card-1.jpg',
      '/images/rallies/chibazoo/spots/chibazoo_59/card-2.jpg',
    ],
    address: '',
  },
  chibazoo_60: {
    thumbnailUrls: [
      '/images/rallies/chibazoo/spots/chibazoo_60/card-1.jpg',
      '/images/rallies/chibazoo/spots/chibazoo_60/card-2.jpg',
    ],
    address: '',
  },

  // ── all ラリー（中部） ─────────────────────────────────────────
  all_62: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_62/card-1.jpg',
      '/images/rallies/all/spots/all_62/card-2.jpg',
    ],
    address: '', // 富山市ファミリーパーク
  },
  all_63: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_63/card-1.jpg',
      '/images/rallies/all/spots/all_63/card-2.jpg',
    ],
    address: '', // いしかわ動物園
  },
  all_64: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_64/card-1.jpg',
      '/images/rallies/all/spots/all_64/card-2.jpg',
    ],
    address: '', // のとじま臨海公園水族館
  },
  all_65: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_65/card-1.jpg',
      '/images/rallies/all/spots/all_65/card-2.jpg',
    ],
    address: '', // 鯖江市西山動物園
  },
  all_66: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_66/card-1.jpg',
      '/images/rallies/all/spots/all_66/card-2.jpg',
    ],
    address: '', // 飯田市立動物園
  },
  all_67: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_67/card-1.jpg',
      '/images/rallies/all/spots/all_67/card-2.jpg',
    ],
    address: '', // 長野市茶臼山動物園
  },
  all_68: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_68/card-1.jpg',
      '/images/rallies/all/spots/all_68/card-2.jpg',
    ],
    address: '', // 富士サファリパーク
  },
  all_69: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_69/card-1.jpg',
      '/images/rallies/all/spots/all_69/card-2.jpg',
    ],
    address: '', // 伊豆アニマルキングダム
  },
  all_70: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_70/card-1.jpg',
      '/images/rallies/all/spots/all_70/card-2.jpg',
    ],
    address: '', // 熱川バナナワニ園
  },
  all_71: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_71/card-1.jpg',
      '/images/rallies/all/spots/all_71/card-2.jpg',
    ],
    address: '', // 伊豆シャボテン動物公園
  },
  all_72: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_72/card-1.jpg',
      '/images/rallies/all/spots/all_72/card-2.jpg',
    ],
    address: '', // 静岡市立日本平動物園
  },
  all_73: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_73/card-1.jpg',
      '/images/rallies/all/spots/all_73/card-2.jpg',
    ],
    address: '', // 浜松市動物園
  },
  all_74: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_74/card-1.jpg',
      '/images/rallies/all/spots/all_74/card-2.jpg',
    ],
    address: '', // 名古屋市東山動植物園
  },
  all_76: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_76/card-1.jpg',
      '/images/rallies/all/spots/all_76/card-2.jpg',
    ],
    address: '', // 岡崎市東公園動物園
  },
  all_77: {
    thumbnailUrls: [
      '/images/rallies/all/spots/all_77/card-1.jpg',
      '/images/rallies/all/spots/all_77/card-2.jpg',
    ],
    address: '', // 名古屋港水族館
  },

  // ── nonhoi ラリー ─────────────────────────────────────────────
  nonhoi_75: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_75/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_75/card-2.jpg',
    ],
    address: '', // のんほいパーク(園内①) マンドリルエリア
  },
  nonhoi_78: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_78/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_78/card-2.jpg',
    ],
    address: '', // のんほいパーク(園内①) マンドリルエリア
  },
  nonhoi_79: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_79/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_79/card-2.jpg',
    ],
    address: '', // のんほいパーク(園内②) 新ゾウ舎(建設中)
  },
  nonhoi_80: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_80/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_80/card-2.jpg',
    ],
    address: '', // のんほいパーク(園内③) 夜行性動物館
  },
  nonhoi_81: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_81/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_81/card-2.jpg',
    ],
    address: '', // JR 二川駅
  },
  nonhoi_82: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_82/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_82/card-2.jpg',
    ],
    address: '', // 豊橋観光案内所
  },
  nonhoi_83: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_83/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_83/card-2.jpg',
    ],
    address: '', // JR 豊橋駅
  },
  nonhoi_84: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_84/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_84/card-2.jpg',
    ],
    address: '', // 吉田城
  },
  nonhoi_85: {
    thumbnailUrls: [
      '/images/rallies/nonhoi/spots/nonhoi_85/card-1.jpg',
      '/images/rallies/nonhoi/spots/nonhoi_85/card-2.jpg',
    ],
    address: '', // 手筒花火体験パーク(豊橋市役所東館13階)
  },
};

/**
 * スポットのメタ情報を取得するヘルパー
 *
 * @param {string} spotId - スポットID（例: "ueno_1"）
 * @returns {{ thumbnailUrls: string[], address: string }}
 */
export const getSpotMeta = (spotId) => {
  return SPOT_META[spotId] ?? { thumbnailUrls: [], address: '住所未設定' };
};